import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  endEditingWhereabouts,
  openRepeatWhereaboutsDialog,
  selectActiveDay,
  selectUserRequiredParking,
  setUserRequiresParking,
  updateMovement
} from '@features/whereabouts/store/editMovements.duck';
import ActivityList from '../../../weekly-movements-setter/components/ActivityList';
import PeriodList from '../../../period-list/PeriodList';
import { BaseProps } from '@shared/models/Props.models';
import './edit-movements-content.scss';
import { Column, Row } from "../../../../atoms/StructuralLayout";
import { BorderlessButton } from "../../../../atoms/buttons/BorderlessButton";
import { IconTypes } from "../../../../atoms/icon/Icon";
import { Checkbox } from "../../../../atoms/Checkbox";
import {
  selectIsCarParkingEnabled,
  selectIsRepeatWeeklyScheduleEnabled
} from '@shared/store/config.duck';
import { UNKNOWN_OPTION } from '@features/whereabouts/services/WhereaboutOptions';
import { PrimaryButton } from "../../../../atoms/buttons/PrimaryButton";
import { SecondaryButton } from "../../../../atoms/buttons/SecondaryButton";
import { HeadlineSmall } from "../../../../atoms/fonts/Headline";

export default function EditMovementsContent(props: BaseProps) {
  const dispatch = useDispatch();
  const className = props.className || '';
  const activeDay = useSelector(selectActiveDay);
  const userRequiresParking = useSelector(selectUserRequiredParking);
  const isCarParkingEnabled = useSelector(selectIsCarParkingEnabled);
  const isRepeatScheduleEnabled = useSelector(selectIsRepeatWeeklyScheduleEnabled);

  const saveWhereabouts = () => {
    dispatch(endEditingWhereabouts());
  }

  const clearWhereabouts = () => {
    dispatch(updateMovement({selectedOption: UNKNOWN_OPTION, locationId: 0, stickOnDay: true}));
  }

  const onRequireParkingSpaceCheckboxChanged = (val: boolean) => {
    dispatch(setUserRequiresParking(val));
  }

  const openRepeatWhereaboutsDialogViaEditWhereaboutsDuck = () => {
    dispatch(openRepeatWhereaboutsDialog());
  }

  return (
    <Column className={`editMovements__content ${className}`.trim()} data-test="edit-movements-panel">
      {activeDay && (
        <div className="editMovements__dayHeader">
          <HeadlineSmall>{activeDay.format('dddd, D MMMM YYYY')}</HeadlineSmall>
        </div>
      )}
      <Row className="editMovements__body">
      <Column className="editMovements__periods">
        <PeriodList/>
        {isCarParkingEnabled && <>
          <Checkbox value={!!userRequiresParking}
                    className={"editMovements__carParking"}
                    onChange={onRequireParkingSpaceCheckboxChanged}
                    text={'whereabouts.require-parking-space'} />
        </>}
        <BorderlessButton className="editMovements__clearBtn"
                          icon={IconTypes.Bin}
                          text="button.clear-day"
                          click={clearWhereabouts}/>
        {isRepeatScheduleEnabled && <>
          <SecondaryButton click={openRepeatWhereaboutsDialogViaEditWhereaboutsDuck}
                           icon={IconTypes.Redo}
                           text={'whereabouts.require-weekly-schedule'} />
        </>}
        <PrimaryButton className="editMovements__saveBtn"
                       text="button.done"
                       click={saveWhereabouts}/>
      </Column>
      <Column className="editMovements__activityList">
        <ActivityList activeDate={activeDay}/>
      </Column>
      </Row>
    </Column>
  )
}
